import { AnyAction } from "redux";
import { IUserState } from "./types";

import {
  FETCH_USER,
  FETCH_USERS,
  UPDATE_USER,
  UPDATE_EXERCISE,
  UPDATE_WORKOUT,
  CREATE_WORKOUT,
  DELETE_WORKOUT,
  UPDATE_CURRENT_WORKOUT,
  CLEAR_CURRENT_WORKOUT,
  UPDATE_CURRENT_EXERCISE
} from "./user.actions";

const defaultState: IUserState = {
  list: [],
  user: {
    _id: "",
    externalId: undefined,
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    gymName: "",
    dob: "",
    address: "",
    gym: "",
    timezone: "",
    firstClassDate: "",
    issueInvoiceAt: undefined,
    logbook: [],
    profile: []
  },
  workout: {
    id: "",
    date: "",
    note: "",
    timestamp: 0
  }
};

export default function usersReducer(
  state: IUserState | undefined = defaultState,
  action: AnyAction
) {
  switch (action.type) {
    case UPDATE_WORKOUT: {
      const currentLogbook = state.user.logbook.filter(
        workout => workout.id === action.requestData.workoutId
      );
      return {
        ...state,
        user: {
          ...state.user,
          logbook: [...currentLogbook, action.payload]
        }
      };
    }
    case CREATE_WORKOUT: {
      return {
        ...state,
        user: {
          ...state.user,
          logbook: [...state.user.logbook, action.payload]
        }
      };
    }
    case DELETE_WORKOUT: {
      const currentLogbook = state.user.logbook.filter(
        workout => workout.id === action.requestData.workoutId
      );
      return {
        ...state,
        user: {
          ...state.user,
          logbook: currentLogbook
        }
      };
    }
    case UPDATE_EXERCISE: {
      const currentLog = state.user.logbook.map(workout => {
        if (workout === action.requestData.workoutId) {
          const currentExercises = (workout.exercises || []).filter(
            exercise => exercise.id === action.requestData.exerciseId
          );
          return {
            ...workout,
            exercises: [...currentExercises, action.payload]
          };
        }
        return workout;
      });
      return {
        ...state,
        user: {
          ...state.user,
          logbook: [...currentLog]
        }
      };
    }
    case FETCH_USER: {
      return {
        ...state,
        user: {
          ...action.payload
        }
      };
    }
    case UPDATE_USER: {
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload
        }
      };
    }
    case FETCH_USERS: {
      return {
        ...state,
        list: [...action.payload]
      };
    }
    case UPDATE_CURRENT_WORKOUT: {
      return {
        ...state,
        workout: {
          ...state.workout,
          ...action.workout
        }
      };
    }
    case CLEAR_CURRENT_WORKOUT: {
      return {
        ...state,
        workout: {
          id: "",
          date: "",
          note: "",
          timestamp: 0
        }
      };
    }
    case UPDATE_CURRENT_EXERCISE: {
      const exercises = (state.workout.exercises || []).map(exercise => {
        if (exercise.id === action.exerciseId) {
          return {
            ...exercise,
            ...action.exercise
          };
        }
        return exercise;
      });
      return {
        ...state,
        workout: {
          ...state.workout,
          exercises
        }
      };
    }
    default:
      return state;
  }
}
